export class UserPermissionToken {
  static IUserPermissionRepository = Symbol("IUserPermissionRepository");
  static UserPermissionUseCase = Symbol("UserPermissionUseCase");
  static UserPermissionViewModel = Symbol("UserPermissionViewModel");
}
